import { render, staticRenderFns } from "./VeriGirisDurumlari.vue?vue&type=template&id=53faf0f8"
import script from "./VeriGirisDurumlari.vue?vue&type=script&lang=js"
export * from "./VeriGirisDurumlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports